import './Toaster.scss'

import { useToaster } from '../../../contexts/Toaster'

const Toaster = ({}) => {
    const toaster = useToaster()

    window.toaster = toaster

    return (
        <aside className="toaster">
            <ul className="toasts">
                {toaster.$state.map((toast) => (
                    <li className={`toast ${toast.type}`} key={toast.id} onClick={() => toaster.remove(toast.id)}>{toast.text}</li>
                ))}
            </ul>
        </aside>
    )
}

export default Toaster